const routes = [
    {
        path: '/contabilidade/dominio_sistemas/fiscal/:hash',
        alias: ['/contabilidade/dominio_sistemas/fiscal/index/:hash'],
        component: () => import('../views/Listar'),
    }
]

export default routes